import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const PayoutByDate = ({ dates, values }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    let chartInstance;

    if (chartRef.current) {
      chartInstance = echarts.init(chartRef.current);

      const option = {
        title: {
          text: "Payout By Date",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56",
            },
          },
        },
        legend: {},
        toolbox: {
          show: true,
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: dates,
        },
        yAxis: {
          type: "value",
          scale: true,
          name: "Total Payout",
          boundaryGap: [0.2, 0.2],
        },
        series: [
          {
            name: "Payout",
            type: "line",
            data: values,
          },
        ],
      };

      chartInstance.setOption(option);

      const handleResize = () => {
        chartInstance.resize();
      };

      window.addEventListener("resize", handleResize);
      return () => {
        chartInstance.dispose();
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [dates, values]);

  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        height: "300px", // Fixed height for the parent
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "16px",
      }}
    />
  );
};

export default PayoutByDate;
